import { render, staticRenderFns } from "./AllowedForm.vue?vue&type=template&id=19896688&"
import script from "./AllowedForm.vue?vue&type=script&lang=js&"
export * from "./AllowedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports